var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-btn-flame-9494d2d3 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.05154 13.2959L11.747 3.79194C11.7717 3.74619 11.8083 3.70797 11.8529 3.68133C11.8976 3.65469 11.9486 3.64062 12.0005 3.64062C12.0525 3.64062 12.1035 3.65469 12.1482 3.68133C12.1928 3.70797 12.2294 3.74619 12.254 3.79194L17.9495 13.2959C17.9889 13.3621 18.0064 13.439 17.9997 13.5157C17.9929 13.5924 17.9623 13.6651 17.912 13.7234L12.2165 16.0664C12.1899 16.0975 12.1569 16.1224 12.1198 16.1395C12.0826 16.1566 12.0422 16.1654 12.0013 16.1654C11.9604 16.1654 11.92 16.1566 11.8828 16.1395C11.8457 16.1224 11.8127 16.0975 11.786 16.0664L6.08904 13.7249C6.03879 13.6666 6.00813 13.5939 6.00141 13.5172C5.99468 13.4405 6.01221 13.3621 6.05154 13.2959Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2591 18.4289L19.6711 21.2549C19.6411 21.4034 19.5166 21.5099 19.3741 21.5099H4.62611C4.55486 21.5079 4.48645 21.4815 4.43236 21.4351C4.37828 21.3887 4.34182 21.325 4.32911 21.2549L3.74111 18.4289H20.2591ZM20.6341 16.6289L22.4926 7.69789C22.5526 7.40689 22.2451 7.18789 22.0186 7.36189L12.0001 14.2499L1.98311 7.36189C1.75511 7.18939 1.44761 7.40689 1.50761 7.69789L3.36761 16.6289H20.6341Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.83048 4.25095L11.611 1.69945C11.6554 1.63751 11.714 1.58704 11.7818 1.55223C11.8496 1.51742 11.9247 1.49927 12.001 1.49927C12.0772 1.49927 12.1523 1.51742 12.2202 1.55223C12.288 1.58704 12.3465 1.63751 12.391 1.69945L14.1715 4.25095C14.2765 4.40095 14.2765 4.59745 14.1715 4.74895L12.391 7.30045C12.3465 7.36238 12.288 7.41285 12.2202 7.44766C12.1523 7.48247 12.0772 7.50063 12.001 7.50063C11.9247 7.50063 11.8496 7.48247 11.7818 7.44766C11.714 7.41285 11.6554 7.36238 11.611 7.30045L9.82898 4.74895C9.77759 4.67609 9.75 4.58911 9.75 4.49995C9.75 4.41078 9.77909 4.32381 9.83048 4.25095Z",
    fill: "#2F80ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSalesIcon);
export default __webpack_public_path__ + "static/media/topSalesIcon.82c669a3859036a67c58a78cc4a9b68f.svg";
export { ForwardRef as ReactComponent };